import _uniq from "lodash.uniq";

const tableConfig = {
  data: {
    pagination: {
      perPage: 25,
      currentPage: 1,
      perPageOptions: [25, 100],
      total: 0
    },
    paginated: false,
    searchQuery: "",
    propsToSearch: ["name", "surname", "fullName", "company"],
    defaultSort: { prop: "fullName", order: "ascending" }
  },
  computed: {
    pagedData() {
      return this.paginated
        ? this.tableData.slice(this.from, this.to)
        : this.tableData;
    },
    queriedData() {
      if (!this.searchQuery) {
        this.pagination.total = this.tableData.length;
        return this.pagedData;
      }
      let result = this.tableData.filter(row => {
        let isIncluded = false;
        for (let key of _uniq(this.propsToSearch)) {
          const foundValue = row[key] || "";

          const rowValue = foundValue.toString();
          const regexQuery = new RegExp(this.searchQuery, "ig");

          if (rowValue.match(regexQuery)) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.tableData.length;
      return this.tableData.length;
    }
  },
  methods: {
    clearFilter() {
      this.searchQuery = "";
      if (!this.$refs.filterTable) {
        return;
      }
      this.$refs.filterTable.clearFilter();
    }
  }
};

export default tableConfig;
